import { BRAND } from "@/lib/constants";

/** Official supplied SVG, rendered as-is (square, never stretched). */
export default function Logo({ size = 44, className = "" }) {
  return (
    <img
      src={BRAND.logo}
      alt="House of Projects"
      width={size}
      height={size}
      className={`block shrink-0 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
